import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 mb-3" }
const _hoisted_2 = { class: "progress mb-2" }
const _hoisted_3 = { class: "form-label" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = {
  class: "form-control",
  id: "inputGroupFile04",
  type: "file",
  "aria-describedby": "inputGroupFileAddon04",
  "aria-label": "Upload",
  ref: "myfile"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "progress-bar",
        role: "progressbar",
        style: _normalizeStyle(`width: ${_ctx.uploadPercentage}%;`)
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.uploadPercentage) + "%", 1)
      ], 4)
    ]),
    _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.label) + " " + _toDisplayString(_ctx.uploadPercentage) + "%", 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("input", _hoisted_5, null, 512),
      _createElementVNode("button", {
        class: "btn btn-outline-secondary",
        id: "inputGroupFileAddon04",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitfile($event)))
      }, "อัปโหลด")
    ])
  ]))
}